import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface WingateSatelliteCardProps {
  avatarUrl?: string;
  username?: string;
}

export const WingateSatelliteCard: React.FC<WingateSatelliteCardProps> = ({ avatarUrl, username }) => {
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        {/* Large satellite image - show full track */}
        <div className="flex justify-center mb-3 md:mb-4">
          <div className="relative" style={{ width: 'fit-content', maxWidth: '100%' }}>
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse rounded-2xl"></div>
            <img
              src="/wingate.satelite.png"
              alt="Wingate Satellite View"
              className="relative rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ 
                maxHeight: '300px',
                maxWidth: '100%',
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                display: 'block'
              }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl">
          <p className="text-base md:text-lg text-yellow-200 font-semibold text-center">
            You mined all your WINGO at Wingate, home of America's premier 320-meter track.
          </p>
        </div>
      </div>
    </WrappedCard>
  );
};

